// Toggle select address
const removeActiveAddress = () => {
  const addresses = document.querySelectorAll('.address-list__item');
  addresses.forEach((item) => {
    item.classList.remove('is-active');
  });
};

attachEvent('.address-list__item-select-btn', 'click', (ev) => {
  const parentElem = ev.target.closest('.address-list__item');
  removeActiveAddress();
  parentElem.classList.toggle('is-active');
  const zipNumber = (parentElem.querySelector('.address-list__item-postcode').innerHTML).replace(/\D/g,'')
  getShippingCost(zipNumber);
});
